import { FC } from "react";
import { IonFabList } from '@ionic/react';
import { AllieFabListProps } from "./FabList.types";

export const AllieFabList: FC<AllieFabListProps> = (props) => <IonFabList {...props} />;
